<template>
  <div>
    <div
      v-if="success"
      class="rounded-md bg-green-50 p-4 mb-2"
    >
      <div
        class="text-sm font-medium text-green-800"
        v-text="success"
      />
    </div>
    <div
      v-if="errors.length > 0"
      class="rounded-md bg-red-50 p-4 mb-2"
    >
      <div
        v-for="(error, index) in errors"
        :key="index"
        class="text-sm font-medium text-red-800"
        v-text="error"
      />
    </div>

    <form
      v-if="!success"
      class="relative"
      @submit.prevent="subscribe"
    >
      <input
        v-model="email"
        type="email"
        class="bg-white w-full border-0 placeholder:text-gray-500 text-black pt-3 pb-2 pr-10"
        placeholder="E-mailadres hier"
      >
      <button
        type="submit"
        class="absolute right-4 top-[14px]"
      >
        <img src="/img/send.svg">
      </button>
    </form>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  data() {
    return {
      email: '',
      loading: false,
      success: null,
      errors: [],
    };
  },

  methods: {
    subscribe() {
      if (this.loading) return false;

      this.loading = true;
      this.errors = [];

      axios.post(this.route('ajax.newsletters.subscribe'), {email: this.email})
      .then((response) => {
        this.success = response.data;
        this.loading = false;
      })
      .catch(error => {
        for (let key of Object.keys(error.response.data.errors)) {
          for (let value of error.response.data.errors[key]) {
            this.errors.push(value);
          }
        }
        this.loading = false;
      });
    },
  },
};
</script>
